import React from "react";
import FallbackImage from "./ImageWrapper";

export default function BranchComp({ branch, onDelete }) {
  return (
    <div className="mb-3">
      <div
        className="py-2 text-center "
        style={{
          background: "#E0E0E0",
          color: "#1E1E1E",
          borderRadius: "10px 10px 0 0",
        }}
      >
        {branch?.branch?.name}
      </div>
      <div style={{}} className="bg-white shadow  pt-4 pb-3  ps-4 pe-4 ">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div
            style={{ background: "var(--color-secondary-soft)" }}
            className="me-3 px-4 py-1 rounded-pill"
          >
            <p className="fw-2 mb-0 h60" style={{ color: "var(--color-secondary-readable)" }}>
              {branch?.branch?.name}
            </p>
          </div>
          <div
            onClick={() => onDelete && onDelete(branch?.branch?.id)}
            style={{ cursor: onDelete ? "pointer" : "default" }}
            title="Delete branch"
          >
            <FallbackImage
              width={24}
              height={24}
              src="/Staff/delete.svg"
              alt="Delete"
            />
          </div>
        </div>
        <div>
          <h6>Address</h6>
          <p className="h60"> {branch?.branch?.address}</p>
        </div>
      </div>
    </div>
  );
}
